import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { getAvatarInitials } from "pages/officeMonitoring/utils";
import {
  IconMoon,
  IconSun,
} from "@tabler/icons-react";

import logoBlack from "../../../assets/img/logo/tmlogoblack.png";
import logoWhite from "../../../assets/img/logo/tmlogowhite.png";

const Header = () => {
  const { accounts } = useMsal();
  const name = accounts[0].name;

  const avatar = name.includes("(")
    ? getAvatarInitials(name.split(" (")[0])
    : getAvatarInitials(name);

  // Apply saved theme on mount
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    if (savedTheme === "dark") {
      document.body.classList.add("theme-dark");
    } else {
      document.body.classList.remove("theme-dark");
    }
  }, []);

  return (
    <header className="navbar navbar-expand-md navbar-light d-print-none">
      <div className="container-xl">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar-menu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <h1 className="navbar-brand d-none-navbar-horizontal pe-0 pe-md-3">
          <a href=".">
            <img
              src={logoBlack}
              width="110"
              height="32"
              alt="Office Monitoring"
              className="navbar-brand-image hide-theme-dark"
            />
            <img
              src={logoWhite}
              width="110"
              height="32"
              alt="Office Monitoring"
              className="navbar-brand-image hide-theme-light"
            />
          </a>
        </h1>

        <div className="navbar-nav flex-row order-md-last">
          {/* <div className="nav-item d-flex me-3">
            <div className="btn-list">
              <a
                href="https://ecentral.trendmicro.com.ph/iDeas/OfficeMonitoring"
                className="btn"
                target="_blank"
                rel="noreferrer"
              >
                <IconSpeakerphone className="icon" />
                Send Feedback
              </a>
            </div>
          </div> */}
          <button
            className=" nav-link px-0 hide-theme-dark bg-transparent"
            title="Enable dark mode"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            onClick={() => {
              document.body.classList.add("theme-dark");
              localStorage.setItem("theme", "dark");
            }}
          >
            <IconMoon className="icon" />
          </button>
          <button
            className="nav-link px-0 hide-theme-light bg-transparent"
            title="Enable light mode"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            onClick={() => {
              document.body.classList.remove("theme-dark");
              localStorage.setItem("theme", "light");
            }}
          >
            <IconSun />
          </button>
          {/* <div className="nav-item dropdown d-none d-md-flex me-3">
            <button
              className="bg-transparent nav-link px-0"
              data-bs-toggle="dropdown"
              tabIndex="-1"
              aria-label="Show notifications"
            >
              <IconBell className="icon" />
              <span className="badge bg-red"></span>
            </button>
            <div className="dropdown-menu dropdown-menu-end dropdown-menu-card">
              <div className="card">
                <div className="card-body text-center">
                  No notifications available
                </div>
              </div>
            </div>
          </div> */}
          <div className="nav-item">
            <div
              className="nav-link d-flex lh-1 text-reset p-0"
              style={{ cursor: "default" }}
            >
              <span className="avatar avatar-sm">{avatar}</span>
              <div className="d-none d-xl-block ps-2">
                <div>{name}</div>
                {/* <div className="mt-1 small text-muted">Manager</div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
